module.exports = __webpack_public_path__ + "img/fan.c7af5132.svg";